import React from 'react';
import { Check } from 'lucide-react';
import './AdvAllStepCss/AdvStepTracker.css';

const AdvStepTracker = ({ currentStep }) => {
  const steps = ['Select Test', 'Date & Time', 'Basic Information', 'Confirmation'];
  
  return (
    <div className="step-tracker">
      {steps.map((step, index) => {
        const isMobileTop = index === 0 || index === 2;
        const isMobileBottom = index === 1 || index === 3;
        return (
          <div key={index} className="step-tracker-item">
            <span
              className={`step-label step-label-top ${
                currentStep === index ? 'step-active-label' : ''
              } ${isMobileTop ? 'mobile-show' : 'mobile-hide'}`}
            >
              {step}
            </span>
            <div 
              className={`step-circle ${currentStep === index ? 'step-active' : ''} ${
                currentStep > index ? 'step-completed' : ''
              }`}
            >
              {currentStep > index ? <Check size={20} /> : index + 1}
            </div>
            <span
              className={`step-label step-label-bottom ${
                currentStep === index ? 'step-active-label' : ''
              } ${isMobileBottom ? 'mobile-show' : 'mobile-hide'}`}
            >
              {step}
            </span>
            <span
              className={`step-label step-label-default ${
                currentStep === index ? 'step-active-label' : ''
              }`}
            >
              {step}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default AdvStepTracker;